import './App.css'
import { useState } from 'react'
import { Search, Sun, Cloud, CloudRain, Building2 } from 'lucide-react'

function App() {
  const [city, setCity] = useState('')
  const [result, setResult] = useState(null)
  const [error, setError] = useState('')
  const [animate, setAnimate] = useState(false)

  async function handleWeatherForm(e) {
    e.preventDefault()

    try {
      const geoRes = await fetch(
        `https://geocoding-api.open-meteo.com/v1/search?name=${city}`
      )
      const geoData = await geoRes.json()

      if (!geoData.results) {
        setResult(null)
        setError('Cidade não encontrada')
        return
      }

      const { latitude, longitude, name, country } = geoData.results[0]

      const weatherRes = await fetch(
        `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`
      )
      const weatherData = await weatherRes.json()

      setAnimate(false)

      setResult({
        city: name,
        country,
        temperature: weatherData.current_weather.temperature,
        weatherCode: weatherData.current_weather.weathercode,
      })

      setError('')
      setTimeout(() => setAnimate(true), 50)
    } catch {
      setError('Erro ao buscar dados')
    }
  }

  function WeatherIcon({ code }) {
    if (code === 0)
      return <Sun size={128} className="icon sun" />

    if (code >= 1 && code <= 48)
      return <Cloud size={128} className="icon cloud" />

    if (code >= 51 && code <= 95)
      return <CloudRain size={128} className="icon rain" />

    return <Cloud size={64} />
  }

  return (
    <div className="App">
      <form onSubmit={handleWeatherForm}>
        <input
          type="text"
          placeholder="Digite sua cidade"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          required
        />
        <button type="submit">
          <Search size={18} />
        </button>
      </form>

      {error && (
        <div className="weather-container animate">
          <div className="weather-state">
            <Building2 size={96} />
            <p className="error">{error}</p>
          </div>
        </div>
      )}

      {result && (
        <div className={`weather-container ${animate ? 'animate' : ''}`}>
          <div className="weather-state">
            <WeatherIcon code={result.weatherCode} />
            <p className="status">
              {result.city}, {result.country}
            </p>
          </div>

          <p className="temp-text">{result.temperature}º</p>
        </div>
      )}
    </div>
  )
}

export default App
